import React, { useEffect, useState } from "react";
import { Box, Paper, Container } from "@mui/material";
import { getHome } from "../services/api/homeApi";

export default function ProductInfoSection() {
  const [homeData, setHomeData] = useState(null);

  useEffect(() => {
    fetchHome();
  }, []);

  const fetchHome = async () => {
    try {
      const data = await getHome();
      setHomeData(data);
    } catch (error) {
      console.error("Failed to fetch home data:", error);
    }
  };

  return (
    <Box sx={{ backgroundColor: "common.white" }}>
      <Container maxWidth="xl">
        <Paper
          elevation={0}
          sx={{
            maxWidth: "1440px",
            mx: "auto",
            px: { xs: 1, sm: 1.5, md: 3, lg: 0 },
            borderRadius: { xs: 3, md: 4 },
            backgroundColor: "background.default",
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)",
              },
              gap: { xs: 3, md: 4 },
              alignItems: "stretch",
            }}
          >
            {/* CARD 1 – IMAGE */}
            <Paper
              elevation={0}
              sx={{
                borderRadius: { xs: 3, md: 4 },
                overflow: "hidden",
                backgroundColor: "background.light",
                height: { xs: 220, sm: 260, md: 350 }, // ✅ FIXED HEIGHT
              }}
            >
              <Box
                component="img"
                src={homeData?.product_info_image1}
                alt="Product Info 1"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </Paper>

            {/* CARD 2 – IMAGE */}
            <Paper
              elevation={0}
              sx={{
                borderRadius: { xs: 3, md: 4 },
                overflow: "hidden",
                backgroundColor: "background.light",
                height: { xs: 220, sm: 260, md: 350 }, // ✅ FIXED HEIGHT
              }}
            >
              <Box
                component="img"
                src={homeData?.product_info_image2}
                alt="Product Info 2"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </Paper>

            {/* CARD 3 – CONTENT */}
            <Paper
              elevation={0}
              sx={{
                borderRadius: { xs: 3, md: 4 },
                backgroundColor: "background.light",
                height: { xs: 220, sm: 260, md: 350 }, // ✅ SAME HEIGHT AS IMAGES
                p: { xs: 1, md: 4 },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  fontSize: { xs: 14, md: 16 },
                  color: "text.secondary",
                  lineHeight: 1.6,



                  "& br": {
                    display: "none",
                  },
                }}
                dangerouslySetInnerHTML={{
                  __html: homeData?.product_info_description || "",
                }}
              />

            </Paper>

          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
